
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apiKeys",
      function () {
        return require("private-next-pages/apiKeys.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apiKeys"])
      });
    }
  